<div class="user-add-container">
    <header>
        <a class="back-button href-btn" *ngIf="!isModal" (click)="cancel()">&lt; Back</a>
        <h1 mat-dialog-title>Add Staff</h1>
        <a class="mobile-cancel-button" fxHide.gt-sm *ngIf="!isModal" (click)="cancel()">Cancel</a>
    </header>

    <div class="userContainer">
        <form [formGroup]="userForm" (ngSubmit)="saveUser()">
            <div mat-dialog-content class="user-info">
                <div class="user-contact-info">
                    <h2>Contact Info</h2>
                    <p>
                        <mat-form-field appearance="outline" *letVar="fields.email as field">
                            <mat-label>Email</mat-label>
                            <input
                                matInput
                                id="email"
                                type="email"
                                lowercase-inp
                                placeholder="Email"
                                formControlName="email"
                                required
                                [errorStateMatcher]="errorMatcher"
                            />
                            <mat-error>
                                <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                            </mat-error>
                        </mat-form-field>
                    </p>
                    <p>
                        <mat-form-field appearance="outline" *letVar="fields.firstName as field">
                            <mat-label>First Name</mat-label>
                            <input
                                matInput
                                id="firstName"
                                type="text"
                                placeholder="First Name"
                                formControlName="firstName"
                                required
                                [errorStateMatcher]="errorMatcher"
                            />
                            <mat-error>
                                <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                            </mat-error>
                        </mat-form-field>
                    </p>
                    <p>
                        <mat-form-field appearance="outline" *letVar="fields.lastName as field">
                            <mat-label>Last Name</mat-label>
                            <input
                                matInput
                                id="lastName"
                                type="text"
                                placeholder="Last Name"
                                formControlName="lastName"
                                required
                                [errorStateMatcher]="errorMatcher"
                            />
                            <mat-error>
                                <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                            </mat-error>
                        </mat-form-field>
                    </p>
                </div>
                <div class="user-company-info">
                    <h2>Company Info</h2>
                    <p>
                        <mat-form-field appearance="outline" *letVar="fields.entityId as field">
                            <mat-label>Company</mat-label>
                            <select matNativeControl id="entityId" formControlName="entityId" required [errorStateMatcher]="errorMatcher">
                                <option value="" selected>Select a company</option>
                                <option *ngFor="let entity of entities$ | async; trackBy: trackById" [value]="entity.id">
                                    {{ entity.name }}
                                </option>
                            </select>
                            <mat-error>
                                <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                            </mat-error>
                        </mat-form-field>
                    </p>
                    <p>
                        <mat-form-field appearance="outline" *letVar="fields.roleId as field">
                            <mat-label>User Type</mat-label>
                            <select matNativeControl id="roleId" formControlName="roleId" required [errorStateMatcher]="errorMatcher">
                                <option value="" selected>Select a user type</option>
                                <option *ngFor="let role of userRoles$ | async; trackBy: trackById" [value]="role.id">
                                    {{ role.name }}
                                </option>
                            </select>
                            <mat-error>
                                <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                            </mat-error>
                        </mat-form-field>
                    </p>
                </div>
            </div>
            <mat-card-actions class="formActionButtonGroup clearfix">
                <button
                    mat-raised-button
                    color="primary"
                    type="submit"
                    class="new-primary-button"
                    [disabled]="!userForm.valid || !fields.email.value"
                >
                    Create
                </button>
                <button mat-stroked-button *ngIf="!emitter.observers.length" (click)="cancel()">Cancel</button>
            </mat-card-actions>
        </form>
    </div>
</div>
